// extracted by mini-css-extract-plugin
export default {"container":"OrderThanksPage_container__loFeu"};